import React, { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { AuthContext, AppSettingsContext } from '../App';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AuthCallback = () => {
  const { setUser } = useContext(AuthContext);
  const appSettings = useContext(AppSettingsContext);
  const navigate = useNavigate();

  useEffect(() => {
    // Check if mobile auth script is handling this
    if (window.__MOBILE_AUTH_ACTIVE__) {
      console.log('[AuthCallback] Mobile auth is active, skipping React handler');
      return;
    }
    
    const handleCallback = async () => {
      console.log('=== AUTH CALLBACK START ===');
      console.log('Full URL:', window.location.href);
      console.log('Hash:', window.location.hash);
      console.log('Search:', window.location.search);
      
      // Check all possible locations for session_id
      const hash = window.location.hash;
      const search = window.location.search;
      
      // Try hash first (#session_id=xxx)
      let sessionId = hash.match(/session_id=([^&]+)/)?.[1];
      
      // Try query params (?session_id=xxx)
      if (!sessionId) {
        const params = new URLSearchParams(search);
        sessionId = params.get('session_id');
      }
      
      // Try just after # without param name (#xxxxx)
      if (!sessionId && hash.length > 1) {
        sessionId = hash.substring(1).split('&')[0];
        console.log('Trying raw hash value:', sessionId);
      }
      
      console.log('Extracted session_id:', sessionId);
      
      if (!sessionId) {
        console.error('❌ No session_id found in URL');
        navigate('/');
        return;
      }

      try {
        console.log('Calling backend with session_id...');
        const response = await axios.post(`${API}/auth/session`, null, {
          headers: { 'X-Session-ID': sessionId }
        });
        
        console.log('✅ Auth successful:', response.data);
        const { user, session_token } = response.data;
        
        // Check if maintenance mode is on and user is not admin
        if (appSettings?.maintenance_mode && !user.is_admin) {
          console.log('❌ Maintenance mode - non-admin user blocked');
          toast.error('Site is under maintenance. Admin access only.');
          navigate('/login');
          return;
        }
        
        setUser(user);
        localStorage.setItem('session_token', session_token);
        
        console.log('✅ Redirecting to dashboard');
        navigate('/dashboard');
      } catch (error) {
        console.error('❌ Auth failed:', error);
        console.error('Error details:', error.response?.data);
        navigate('/');
      }
    };

    handleCallback();
  }, [navigate, setUser, appSettings]);

  // If mobile auth is active, show nothing (mobile script handles UI)
  if (window.__MOBILE_AUTH_ACTIVE__) {
    return null;
  }

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900">
      <div className="text-white text-xl">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white mx-auto mb-4"></div>
        Completing login...
      </div>
    </div>
  );
};

export default AuthCallback;
